__webpack_require__.p = "https://bmidxbportugalplprod.netlify.app/";